export default __webpack_public_path__ + "static/media/calcV2.54b2cfe8.svg";